"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _UIAutosizedTextInput = _interopRequireDefault(require("UIComponents/input/UIAutosizedTextInput"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var InlineTextInputWithValidation = _react.default.createClass({
  displayName: "InlineTextInputWithValidation",
  propTypes: {
    id: _react.PropTypes.string,
    labelTooltip: _react.PropTypes.node,
    placeholder: _react.PropTypes.string,
    isInvalid: _react.PropTypes.bool,
    inline: _react.PropTypes.bool,
    invalidMessage: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]),
    onBlur: _react.PropTypes.func,
    onChange: _react.PropTypes.func,
    value: _react.PropTypes.string,
    className: _react.PropTypes.string,
    description: _react.PropTypes.node
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        invalidMessage = _this$props.invalidMessage,
        id = _this$props.id,
        isInvalid = _this$props.isInvalid,
        onChange = _this$props.onChange,
        placeholder = _this$props.placeholder,
        value = _this$props.value;
    return _react.default.createElement("div", {
      className: className
    }, !isInvalid ? null : _react.default.createElement("span", {
      className: "secondary-navigation__validation-count secondary-navigation__count-white"
    }, _react.default.createElement(_UITooltip.default, {
      placement: "bottom",
      title: invalidMessage
    }, _react.default.createElement("span", null, "1"))), _react.default.createElement(_UIAutosizedTextInput.default, {
      affordance: true,
      id: id,
      onChange: onChange,
      placeholder: placeholder,
      use: "on-dark",
      value: value
    }));
  }
});

var _default = InlineTextInputWithValidation;
exports.default = _default;
module.exports = exports.default;